import React, {useState} from 'react'
import { Globe,FormUpload } from 'grommet-icons';
import CountriesDropdown from './countryDropdown'
import { Box, Button,Card, FormField,TextInput,CardHeader,Form,DateInput,Text,CardBody } from 'grommet';
import {NavigationSnackBar, ReturnRowDir,ShipmentQuoteDetailFormElements} from './utils/shared/shared'


const LocationCard = (props) => {
    const [postCodeRequired, setPostCodeRequired] = useState(true)
    return (
        <Card elevation='large' margin='small' pad='small' background={'background-front'}>
        <CardHeader justify='start'>
        <Globe color='status-ok'/><Text weight={'bold'}>{props.label}</Text>
        </CardHeader>
        <CardBody direction='row'>
            <CountriesDropdown size='xsmall' requote={props.requote} name={props.label} value={props.quote} setPostCodeRequired={setPostCodeRequired} />
        </CardBody>
            <CardBody direction='row'>
            <FormField required label={<Text size='xsmall'>City</Text>} name={props.city} margin='small' >
                <TextInput size='xsmall' name={props.city} placeholder="Enter City" />
            </FormField>
            {(postCodeRequired && <FormField required label={<Text size='xsmall'>Postal/Zip Code</Text>}  name={props.postcode} margin='small' >
                <TextInput name={props.postcode} size='xsmall' placeholder="Enter Postal/Zip Code..." />
            </FormField>
            )}
            </CardBody>
        </Card>
    )
    
}

function CreateQuoteForm(props){
    return (
        <Box>
             <NavigationSnackBar title={'Quick Quote'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'}]}  />
            <Box align='center' >
            <Form value={props.quote} onSubmit={props.handleSubmit} onChange={nextValue => props.setQuote(nextValue)}>
                <Box direction='row' justify='between'>
                    <LocationCard requote={props.requote} quote={props.quote} label={"Origin"} city={"OriginCity"} postcode={"OriginPostCode"} />
                    <LocationCard requote={props.requote} quote={props.quote} label={"Destination"} city={"DestinationCity"} postcode={"DestinationPostCode"} />
                </Box>
                <Box direction={ReturnRowDir(props.size)} justify='center' elevation='large' round margin='small' pad='small' background={'background-front'}>
                <Box durection='row'></Box>
                <FormField name="PickupDateTime" label={<Text size='xsmall'>Collection Date</Text>} required margin='small'>
                <DateInput calendarProps={{daysOfWeek: true}} size='xsmall'firstDayOfWeek={0} name="PickupDateTime" format="dd/mm/yyyy" label="Collection Date"/>
                </FormField>
                {ShipmentQuoteDetailFormElements.map(item => {
                    return (
                        <FormField name={item.name} label={<Text size='xsmall'>{item.placeholder}</Text>} required margin='small'>
                            <TextInput size='xsmall' name={item.name} icon={item.icon} placeholder={item.placeholder} type={item.type}/>
                        </FormField>
                    )
                })}
                </Box> 
                    <Button hoverIndicator margin='medium' primary label="Submit" type='submit' icon={<FormUpload />}/>
                </Form> 
            </Box>
            </Box>
    )

}

export default CreateQuoteForm